import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.create-credit-card-bill.presenters.CreateCreditCardBillFormPresenter`

export default defineMessages({
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Bill Created',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: 'Bill has been successfully created',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  genericErrorMessage: {
    id: `${scope}.genericErrorMessage`,
    defaultMessage: 'Something went wrong. Please try again.',
  },
  uploadErrorMessage: {
    id: `${scope}.uploadErrorMessage`,
    defaultMessage: 'Unable to upload the invoice. Please try again.',
  },
})
